import React from "react";
import SchoolDayGuide from "./components/SchoolDayGuide";
import Arcade from "@/pages/Arcade";
import "@/App.css";
import {
    BrowserRouter,
    Routes,
    Route,
    Navigate,
    useLocation,
    useParams,
} from "react-router-dom";
import Login from "@/pages/Login";
import HomePage from "@/pages/HomePage";
import Plans from "@/pages/Plans";
import AuthCallback from "@/pages/AuthCallback";
import Settings from "@/pages/Settings";
import Quests from "@/pages/Quests";
import Codex from "./pages/Codex";
import ParentProfile from "@/pages/ParentProfile";
import { Toaster } from "@/components/ui/sonner";
import { ClassroomProvider } from "./context/ClassroomProvider";
import ParentClassroom from "./pages/ParentClassroom";
import ChildClassroom from "./pages/ChildClassroom";
import ChildLogin from "./pages/ChildLogin";
import ChildDashboard from "./pages/ChildDashboard";
import ChildBreakRoom from "./pages/ChildBreakRoom";


function RetiredHouseholdPage() {
    const { childId } = useParams();
    return <Navigate to={childId ? `/child/home/${encodeURIComponent(childId)}?desk=chores` : "/profile"} replace />;
}

function AppRouter() {
    const location = useLocation();
    return (
        <Routes>
            <Route
                path="/"
                element={<HomePage />}
            />

            <Route
                path="/parent/login"
                element={<Login />}
            />

            <Route
                path="/plans"
                element={<Plans />}
            />

            <Route
                path="/login"
                element={<Navigate to="/parent/login" replace />}
            />
            <Route
                path="/child/login"
                element={<ChildLogin />}
            />
            <Route
                path="/child/dashboard/:childId"
                element={<ChildDashboard />}
            />
            <Route
                path="/child/home/:childId"
                element={<ChildDashboard />}
            />
            <Route path="/pet/:childId" element={<RetiredHouseholdPage />} />
            <Route
                path="/child/classroom/:childId"
                element={<ChildClassroom />}
            />
            <Route
                path="/child/classroom/:childId/:subjectId"
                element={<ChildClassroom />}
            />
            <Route
                path="/child/break-room/:childId"
                element={<ChildBreakRoom />}
/>
            <Route path="/settings" element={<Settings />} />
            <Route path="/quests/:childId" element={<Quests />} />
            <Route path="/codex/:childId" element={<Codex />} />
           

            <Route path="/profile" element={<ParentProfile />} />
            <Route
                path="/parent/classroom/:childId/:subjectId"
                element={
                    <ClassroomProvider>
                        <ParentClassroom />
                    </ClassroomProvider>
                }
            />

            <Route path="/hearth-rites/:childId" element={<RetiredHouseholdPage />} />
            <Route path="/hearth-board" element={<Navigate to="/profile" replace />} />
            <Route path="/hearth-board/:childId" element={<Navigate to="/profile" replace />} />
            <Route path="/arcade/:childId" element={<Arcade />} />            
        </Routes>
    );
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AppRouter />
                <SchoolDayGuide />
                <Toaster theme="dark" />
            </BrowserRouter>
        </div>
    );
}

export default App;
